import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Loader2 } from "lucide-react";

export default function RequireAdmin({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="animate-spin text-cyan-600" size={40} />
      </div>
    );
  }

  // Fallback to localStorage in case React state hasn't flushed yet
  const effectiveUser = user || (() => {
    try {
      const stored = localStorage.getItem("mms_user");
      return stored ? JSON.parse(stored) : null;
    } catch { return null; }
  })();

  const hasToken = !!localStorage.getItem("mms_token");

  if (!hasToken || !effectiveUser || effectiveUser.role !== "admin") {
    return <Navigate to="/admin/login" state={{ from: location.pathname }} replace />;
  }
  return children;
}
